import React, { useState, useEffect } from "react";
import "./portal.css";
import Sidepanel from "./sidepanel";
import Question from "./question";
import { Drawer, Typography } from "antd";
import SiderQImage from "../../../assets/siderQImage.svg";
// import Clock from "./clock"; // Optional
// import TestBoardHeader from "./TestBoardHeader";
import Operations from "./operations";

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => setWindowDimensions(getWindowDimensions());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
};

export default function TestBoard({loading}) {
  const { width } = useWindowDimensions();
  const [visible, setVisible] = useState(false);
  const [sideQuestion, setSideQuestion] = useState(false);

  const mode = width > 768 ? "desktop" : "mobile";

  const handleToggleQuestion = () => setSideQuestion((prev) => !prev);
  const onClose = () => setVisible(false);
  const onOpen = () => setVisible(true);

  return (
    <div className="exam-dashboard-wrapper-new">
      <Question
        mode={mode}
        triggerSidebar={onOpen}
        loading={loading}
      />

      {mode === "desktop" ? (
        <div className="side_panel">
          <div className="side-panel-toggle">
            <img
              width="80%"
              style={{ cursor: "pointer" }}
              src={SiderQImage}
              alt="Toggle Question"
              onClick={handleToggleQuestion}
            />
          </div>
          {sideQuestion && (
            <div className="side_Question">
              <Operations />
            </div>
          )}
        </div>
      ) : (
        <Drawer
          title="Toolbar"
          placement="right"
          closable
          onClose={onClose}
          open={visible}
          width={Math.min(width, 480)}
        >
          <Sidepanel mode={mode} />
        </Drawer>
      )}
    </div>
  );
}
